export type CardFeeAPI = {
  terminalType?: TerminalTypeAPI;
  percentage?: number;
  cardProviderName?: string;
};

export enum TerminalTypeAPI {
  CARD_NOT_PRESENT = 'CARD_NOT_PRESENT',
  CARD_PRESENT = 'CARD_PRESENT',
}
